// removed by extract-text-webpack-plugin
module.exports = {"wrapper-input":"magazines_3-S9i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Input/styles.scss
// module id = 1122
// module chunks = 1